'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = undefined;

var _validation = require('utils/validation');

var colors = exports.colors = ['Blue', 'Fuchsia', 'Green', 'Orange', 'Red', 'Taupe'];

var widgetValidation = (0, _validation.createValidator)({
  color: [_validation.required, (0, _validation.oneOf)(colors)],
  sprocketCount: [_validation.required, _validation.integer],
  owner: [_validation.required, (0, _validation.maxLength)(30)]
});
exports.default = widgetValidation;


//////////////////
// WEBPACK FOOTER
// ./src/components/WidgetForm/widgetValidation.js
// module id = 1201
// module chunks = 0